export interface FormattedPriceSettings {
  priceSettingsId?: number
  type?: PriceSettingsType
  paymentMethod?: PriceSettingsPaymentMethod
  price?: number
  currency?: string
  availabilityPeriodLength?: number
  availabilityPeriodTimeUnit?: PriceSettingsAvailabilityPeriodTimeUnit
  bundle?: {
    id?: number
    externalId?: string
    name?: string
  }
  formattedType?: PriceSettingsFormattedType
  priceString?: string
  text: string
}

export const PriceSettingsFormattedType = {
  Buy: 'BUY',
  Rent: 'RENT',
} as const
export type PriceSettingsFormattedType =
  (typeof PriceSettingsFormattedType)[keyof typeof PriceSettingsFormattedType]

export const PriceSettingsType = {
  Purchase: 'PURCHASE',
  Rent: 'RENT',
} as const
export type PriceSettingsType =
  (typeof PriceSettingsType)[keyof typeof PriceSettingsType]

export const PriceSettingsPaymentMethod = {
  PerItem: 'PER_ITEM',
  PerSet: 'PER_SET',
} as const
export type PriceSettingsPaymentMethod =
  (typeof PriceSettingsPaymentMethod)[keyof typeof PriceSettingsPaymentMethod]

export const PriceSettingsAvailabilityPeriodTimeUnit = {
  Day: 'DAY',
  Month: 'MONTH',
  Year: 'YEAR',
} as const
export type PriceSettingsAvailabilityPeriodTimeUnit =
  (typeof PriceSettingsAvailabilityPeriodTimeUnit)[keyof typeof PriceSettingsAvailabilityPeriodTimeUnit]
